@if (contactpersonId$ | async; as contactpersonId) {
  <div data-test="contactperson-navigation">
    @if (!!contactpersonId) {
      <nav mat-tab-nav-bar [tabPanel]="tabPanel" color="accent">
        <a
          mat-tab-link
          [routerLink]="['/contactperson', contactpersonId]"
          [active]="isDetails$ | async"
          >{{ 'app.contactperson.navigation.details' | translate }}
        </a>
        <a
          mat-tab-link
          [routerLink]="['/contactperson', contactpersonId, 'relations']"
          [active]="isRelations$ | async"
          >{{ 'app.contactperson.navigation.relations' | translate }}
        </a>
        <a
          mat-tab-link
          [routerLink]="['/contactperson', contactpersonId, 'authorizations']"
          [active]="isAuthorizations$ | async"
          >{{ 'app.contactperson.navigation.authorizations' | translate }}
        </a>
      </nav>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    }
  </div>
}
